import { FC, useEffect, useRef, useState } from "react";
import styles from "./CatalogPage.module.scss";
import { ICatalogObject, IFirstRowItem } from "@/lib/types/catalogPage";
import Image from "next/image";
import { Search } from "@/lib/ui/components/Search";
import { TopBlock } from "@/lib/ui/blocks/page-specific/Catalog/TopBlock/TopBlock";
import { CatalogFilter } from "@/lib/ui/blocks/page-specific/Catalog/CatalogFilter";
import { Properties } from "@/lib/ui/blocks/page-specific/Catalog/Properties";
import { useCatalogActions } from "@/lib/store/slices/catalog";
import { useObserver } from "../../hooks/useObserver";
import { CatalogDownload } from "../../ui/blocks/page-specific/Catalog/CatalogDownload";
import { Breadcrumbs } from "../../ui/components/Breadcrumbs/Breadcrumbs";
import { useTranslation } from "next-i18next";

interface ICatalogPageData {
  data: ICatalogObject[];
  filteredData: ICatalogObject[];
  firstRowItems: IFirstRowItem[];
  title: string;
}

export const CatalogPage: FC<ICatalogPageData> = ({
  data,
  firstRowItems,
  title,
  filteredData,
}) => {
  const isFirstRender = useRef(true);
  const { t } = useTranslation("index");
  const [isScrolled, setIsScrolled] = useState(false);
  const downloadRef = useRef<HTMLDivElement>(null);
  useObserver({ ref: downloadRef, isInterTrue: () => setIsScrolled(true), isOnce: true });
  const { setProperties } = useCatalogActions();
  useEffect(() => {
    isFirstRender.current = false;
    if (data.length > 0) {
      setProperties(data);
    }
  }, [data, setProperties]);

  return (
    <div className={styles.catalog}>
      <Image
        className={styles.catalog__leaves}
        src={"/palmsTransparent.webp"}
        width={1505}
        height={1000}
        sizes="1505px"
        alt=""
        priority
      />
      <div className={styles.container}>
        <Breadcrumbs
          items={[{ title: "VillaCarte", link: "/" }, { title: t("salesCatalog") }]}
          className={styles.catalog__bread}
        />
        <TopBlock title={title} />
        <CatalogFilter
          secondRowContentMobile={<Search isInFilter />}
          firstRowItems={firstRowItems}
        />
        <Properties data={isFirstRender.current ? filteredData : data} />
      </div>
      <div ref={downloadRef} />
      {isScrolled && <CatalogDownload />}
    </div>
  );
};
